module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logo.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "home-nsp-intro",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Nucleic acids"), _c('br'), _vm._v("Structure Prediction")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/doc"
    }
  }, [_vm._v("Documentation")])]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "https://github.com/hust220/nsp"
    }
  }, [_vm._v("Github")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-370ff164!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 88
// module chunks = 2